import Vue from 'vue'
import { isDev } from '~/utils/env'

let appConfigs = {}
if (isDev()) {
  appConfigs.customerUrl = "http://localhost:3000"
} else {
  appConfigs.customerUrl = "https://cus.joseikin-shien.com"
}